import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Transmision } from './../../../_entities/consola/transmision';
import { environment } from './../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransmisionesService {

  constructor(private http: HttpClient) { }

  obtenerTransmisiones(imei, numero): Observable<Transmision[]> {
    return this.http.get<Transmision[]>(environment.API_SECURITY + '/api/Consola', {
      params: {
        imei,
        numero
      }
    });
  }
}
